import { render, staticRenderFns } from "./delete-modal.vue?vue&type=template&id=0ea137a2&"
import script from "./delete-modal.component.ts?vue&type=script&lang=ts&"
export * from "./delete-modal.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports